export const Dialog = {
    MuiDialogTitle: {
        defaultProps: {
            variant: "textXl"
        },
        styleOverrides: {
            root: ({ theme })=>({
                    padding: theme.spacing(3, 3, 0, 3),
                    fontWeight: 500
                })
        }
    },
    MuiDialogContent: {
        styleOverrides: {
            root: ({ theme })=>({
                    padding: theme.spacing(3)
                })
        }
    },
    MuiDialogContentText: {
        defaultProps: {
            variant: "textSm"
        },
        styleOverrides: {
            root: ({ theme })=>({
                    color: theme.palette.text.textHelper
                })
        }
    },
    MuiDialogActions: {
        styleOverrides: {
            root: ({ theme })=>({
                    padding: theme.spacing(1, 3, 3, 3)
                })
        }
    }
};

//# sourceMappingURL=Dialog.js.map